import { render } from "./serviceprovider.configuration.vue?vue&type=template&id=36b099f8"
import script from "./serviceprovider.configuration.vue?vue&type=script&lang=js"
export * from "./serviceprovider.configuration.vue?vue&type=script&lang=js"

import "./serviceprovider.configuration.vue?vue&type=style&index=0&id=36b099f8&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__